import { Component, Input, forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {forEach} from '@angular-devkit/schematics';

@Component({
    selector: 'validation-input',
    templateUrl: './validation-input.component.html',
    styleUrls: ['./validation-input.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ValidationInputComponent),
        multi: true
    }]
})
export class ValidationInputComponent implements ControlValueAccessor {

    @Input()
    public border = true;

    @Input()
    public label: string;

    @Input()
    public quebrarLinhaLabel: boolean = false;

    @Input()
    public validationMessages: Array<any>;

    @Input()
    public formControl: FormControl;

    private value: any;
    private onChange: any = () => { };
    private onTouch: any = () => { };

    constructor() {

    }

    writeValue(obj: any): void {
        if (obj !== undefined && this.value !== obj) {
            this.value = obj;
            this.onChange(obj);
            this.onTouch(obj);
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    validarCampo() {
        let validacao = false;
        if (this.validationMessages) {
            this.validationMessages.forEach((item) => {
                if(!this.formControl || !this.formControl.hasError) {
                    console.log(this.formControl, item);
                    return;
                }
                if (this.formControl.hasError(item.type) && (this.formControl.dirty || this.formControl.touched)) {
                    validacao = true;
                }
            });
        }
        return validacao;
    }

}
